import React, { useMemo } from 'react';
import styles from './UIGameBankPortrait.module.scss';
import BankIcon from '@static/images/bank.svg';
import { UIGameCardInventory } from '../../common/UIGameCardInventory/UIGameCardInventory.tsx';
import { getBankCardTooltip } from '../UIGameBank/getBankCardTooltip.tsx';
import { useUIGameTranslationContext } from '../../contexts/UIGameTranslationContext.tsx';
export const UIGameBankPortrait = ({ cardState, cardStackSizes, hideBankCards, modeSetting, progressCards })=>{
    const { translationKeyContext } = useUIGameTranslationContext();
    const cardTooltipOverrides = useMemo(()=>{
        const overrides = {};
        for (const cardEnumStr of Object.keys(cardState)){
            const cardEnum = Number(cardEnumStr);
            var _cardState_cardEnum;
            const count = (_cardState_cardEnum = cardState[cardEnum]) !== null && _cardState_cardEnum !== void 0 ? _cardState_cardEnum : 0;
            overrides[cardEnum] = getBankCardTooltip(cardEnum, count, hideBankCards, modeSetting, progressCards, translationKeyContext);
        }
        return overrides;
    }, [
        cardState,
        hideBankCards,
        modeSetting,
        progressCards,
        translationKeyContext
    ]);
    // Cards with count 0 are excluded by CardValidatorUnordered, so we transform
    // the data to keep them visible as greyed-out single cards with no badge.
    const { displayCardState, displayCardStackSizes, emptyCardEnums, cardsToDisable } = useMemo(()=>{
        const displayState = {};
        const displayStackSizes = {};
        const emptyEnums = [];
        const disable = {};
        for (const cardEnumStr of Object.keys(cardState)){
            const cardEnum = Number(cardEnumStr);
            var _cardState_cardEnum;
            const count = (_cardState_cardEnum = cardState[cardEnum]) !== null && _cardState_cardEnum !== void 0 ? _cardState_cardEnum : 0;
            if (count === 0) {
                displayState[cardEnum] = 1;
                displayStackSizes[cardEnum] = 1;
                emptyEnums.push(cardEnum);
                disable[cardEnum] = 1;
            } else {
                displayState[cardEnum] = count;
                var _cardStackSizes_cardEnum;
                displayStackSizes[cardEnum] = (_cardStackSizes_cardEnum = cardStackSizes[cardEnum]) !== null && _cardStackSizes_cardEnum !== void 0 ? _cardStackSizes_cardEnum : count;
            }
        }
        return {
            displayCardState: displayState,
            displayCardStackSizes: displayStackSizes,
            emptyCardEnums: emptyEnums,
            cardsToDisable: disable
        };
    }, [
        cardState,
        cardStackSizes
    ]);
    const isCitiesAndKnights = progressCards != undefined;
    return /*#__PURE__*/ React.createElement("div", {
        id: "bank-container",
        "data-bank-icon": true,
        className: styles.container
    }, !isCitiesAndKnights && /*#__PURE__*/ React.createElement("img", {
        src: BankIcon,
        className: styles.bankIcon
    }), /*#__PURE__*/ React.createElement(UIGameCardInventory, {
        cardSize: "xxs",
        cardStackSizes: displayCardStackSizes,
        cardStackDirection: "vertical",
        enablePartition: false,
        cardState: displayCardState,
        cardsToDisable: cardsToDisable,
        cardsToHideBadge: emptyCardEnums,
        forceShowCardBadges: !hideBankCards,
        cardTooltipOverrides: cardTooltipOverrides
    }));
};
